import React, { useState } from 'react';
import { AssignmentDisplayData } from 'types/assignment';
import { ScrollableTabs, TabsItem } from '@fattureincloud/fic-design-system';
import { TabNames } from '../constants';
import { getMobileTabs } from '../utils';
import style from '../../style.module.scss';
import { AssignmentDetails } from './assignmentDetails';
import { CondominiumData } from './condominiumData';
import { CondominiumImplantData } from './condominiumImplant';
import { ActivityData } from './activityData';
import { DetailsSingleDatum } from './detailsSingleDatum';
import { AppplicantView } from './applicantView';
import { MobileForwardDetails } from './forwardDetails';
import { useSelector } from 'react-redux';
import { selectors } from 'utils/reduxSelector';
import { nullcheckAllObjProperty } from 'utils/object';

type Props = { assignment: AssignmentDisplayData };

export const MobileView: React.FC<Props> = ({
  assignment: { details, condominium, condominumImplant, activity, pid, forward }
}) => {
  const [currentTab, setCurrentTab] = useState(TabNames.Attività);
  const canForwardAssignment = useSelector(selectors.assignmentSelector.canForwardAssignment);
  const addForwardTab = canForwardAssignment && nullcheckAllObjProperty(forward);
  const tabs: TabsItem[] = getMobileTabs(currentTab, setCurrentTab, addForwardTab);

  const currentContent = {
    [TabNames.Dettagli]: (
      <>
        <AssignmentDetails details={details} pid={pid} />
        <DetailsSingleDatum title="Amministratore" value={details.amministratoreNome} />
        <DetailsSingleDatum title="Operatore" value={details.attivitaOperatore} />
        <AppplicantView
          attivitaReferente={details.attivitaReferente}
          attivitaReferenteContatto={details.attivitaReferenteContatto}
        />
      </>
    ),
    [TabNames.Condominio]: (
      <>
        <CondominiumData condominium={condominium} />
        <CondominiumImplantData condominumImplant={condominumImplant} />
      </>
    ),
    [TabNames.Attività]: <ActivityData activity={activity} />,
    [TabNames.Inoltro]: addForwardTab ? <MobileForwardDetails forward={forward} /> : <></>
  };

  return (
    <>
      <div className="tabs__border">
        <ScrollableTabs tabs={tabs} />
      </div>
      <div className="px-4 pt-3">
        <p className="semibold">Richiesta di intervento a {details.fornitoreNome}&#58;</p>
      </div>
      <div className={style['assignment-container']}>{currentContent[currentTab]}</div>
    </>
  );
};
